import EncrptionInterceptor from "../lib/encryptionInterceptor";
const url = "querymanager/insurance/web-requests/verify-captcha";
const api = EncrptionInterceptor();

// Checked immediately on "Get a Quote" / "Send us a Message", before the
// OTP round-trip — a wrong captcha needs to surface right away, not after
// the customer's already sent/entered an OTP. On success returns a
// short-lived, one-shot proofToken that createWebRequest sends instead of
// the raw captcha (which is already consumed by this call either way).
export async function verifyCaptcha(captchaId, captchaAnswer) {
  const payload = { captchaId, captchaAnswer };
  // Plain payload before EncrptionInterceptor turns it into { data, key }.
  console.log("verify-captcha payload:", payload);
  const response = await api.post(url, payload);
  return response.data;
}
